import {
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Collapse,
  TextField,
  InputAdornment,
  Box,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";

export const FilterSectionWrapper = ({ id, children }) => {
  return <div id={id}>{children}</div>;
};

FilterSectionWrapper.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
};

export const FilterSectionHeader = ({
  isOpen,
  onClick,
  title,
  count,
}) => {
  return (
    <List
      sx={{
        width: "100%",
        maxWidth: 383,
        bgcolor: "background.paper",
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <ListItemButton
        onClick={onClick}
        sx={{
          fontSize: "14px",
          fontWeight: "500",
          color: "#121415",
        }}
      >
        {isOpen ? (
          <ArrowDropUpIcon style={{ color: "#414344 !important" }} />
        ) : (
          <ArrowDropDownIcon style={{ color: "#717273 !important" }} />
        )}
        <ListItemText
          primary={title}
          disableTypography
          sx={{
            fontSize: "16px !important",
            fontWeight: "500 !important",
            color: "#121415",
          }}
        />
        {count && (
          <span
            style={{
              fontSize: "14px",
              color: "#121415",
              marginLeft: "auto",
            }}
          >
            {count}
          </span>
        )}
      </ListItemButton>
    </List>
  );
};

FilterSectionHeader.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const AllCheckboxItem = ({
  onClick,
  checked,
  indeterminate,
  fontWeight,
}) => {
  return (
    <List component="div">
      <ListItemButton sx={{ height: "30px" }} onClick={onClick}>
        <ListItemIcon sx={{ minWidth: "20px" }}>
          <Checkbox
            edge="start"
            checked={checked}
            indeterminate={indeterminate}
            disableRipple
            sx={{ padding: 0, marginRight: 1 }}
          />
        </ListItemIcon>
        <ListItemText
          disableTypography
          primary="All"
          sx={{
            fontSize: "14px",
            fontWeight: fontWeight || "500 !important",
          }}
        />
      </ListItemButton>
    </List>
  );
};

AllCheckboxItem.propTypes = {
  onClick: PropTypes.func,
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  fontWeight: PropTypes.string,
};

export const CheckboxListItem = ({
  item,
  isChecked,
  onClick,
  disabled,
  customStyles,
}) => {
  return (
    <List
      component="div"
      key={item}
      sx={{
        paddingTop: "2px!important",
        paddingBottom: "2px!important",
      }}
    >
      <ListItemButton
        sx={{
          minWidth: "0px !important",
          borderRadius: "4px!important",
          paddingTop: "0px!important",
          paddingBottom: "0px!important",
          height: "30px!important",
          backgroundColor: isChecked ? "#E5F3FF!important" : "",
          color: isChecked ? "#0476E2!important" : "#2A2C2D!important",
          cursor: customStyles?.cursor || "default",
          ...customStyles,
        }}
        onClick={onClick}
      >
        <ListItemIcon sx={{ minWidth: "20px" }}>
          <Checkbox
            edge="start"
            checked={isChecked}
            tabIndex={-1}
            disableRipple
            disabled={disabled}
            slotProps={{ "aria-labelledby": item }}
            sx={{ padding: 0, marginRight: 1 }}
          />
        </ListItemIcon>
        <ListItemText
          disableTypography
          sx={{
            fontSize: "14px",
            fontWeight: isChecked ? "600!important" : "500!important",
            ...(customStyles?.color && { color: customStyles.color }),
          }}
          primary={item}
        />
      </ListItemButton>
    </List>
  );
};

CheckboxListItem.propTypes = {
  item: PropTypes.string,
  isChecked: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  customStyles: PropTypes.object,
};

export const SearchBox = ({
  selectAllFlag,
  onUnselectClick,
  placeholder,
  onChange,
  searchValue,
}) => {
  return (
    <div className="versionListDivCls">
      <Box
        className="searchCreateBtnCls"
        component="form"
        noValidate
        autoComplete="off"
      >
        {!selectAllFlag && (
          <button type="button" className="selectAllTextCls" onClick={onUnselectClick}>
            Unselect All
          </button>
        )}
        {selectAllFlag && (
          <button type="button" className="selectAllTextCls" onClick={onUnselectClick}>
            Select All
          </button>
        )}

        <TextField
          type="search"
          placeholder={placeholder}
          size="small"
          value={searchValue}
          style={{
            backgroundColor: "white",
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            },
          }}
          onChange={onChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
        />
      </Box>
    </div>
  );
};

SearchBox.propTypes = {
  selectAllFlag: PropTypes.bool,
  onUnselectClick: PropTypes.func,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  searchValue: PropTypes.string,
};

export const EmptyStateMessage = ({ message }) => {
  return (
    <div
      className="listDivCls"
      style={{
        width: "100%",
        maxWidth: "383px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
        border: "1px solid #e9ecef",
        borderRadius: "4px",
        margin: "0 auto",
        padding: "0 8px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
        }}
      >
        <WarningIcon
          style={{
            fontSize: "12px",
            color: "#6c757d",
          }}
        />
        <span
          style={{
            fontSize: "12px",
            color: "#6c757d",
            fontWeight: "500",
            whiteSpace: "nowrap",
          }}
        >
          {message}
        </span>
      </div>
    </div>
  );
};

EmptyStateMessage.propTypes = {
  message: PropTypes.string,
};

export const FilterListContainer = ({ isOpen, children }) => {
  return (
    <Collapse in={isOpen} timeout="auto" unmountOnExit>
      <div className="listDivCls">{children}</div>
    </Collapse>
  );
};

FilterListContainer.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.node,
};

export const SearchableFilterContainer = ({
  isOpen,
  searchPlaceholder,
  onSearchChange,
  selectAllFlag,
  onUnselectClick,
  searchValue,
  helperText,
  onKeyDown,
  children,
}) => {
  return (
    <Collapse in={isOpen} timeout="auto" unmountOnExit>
      {helperText && (
        <span
          style={{
            fontSize: "12px",
            padding: "6px ",
            marginLeft: "39px",
          }}
        >
          {helperText}
        </span>
      )}
      <div className="versionListDivCls">
        <Box
          className="searchCreateBtnCls"
          component="form"
          noValidate
          autoComplete="off"
        >
          {!selectAllFlag && (
            <button type="button" className="selectAllTextCls" onClick={onUnselectClick}>
              Unselect All
            </button>
          )}
          {selectAllFlag && (
            <button type="button" className="selectAllTextCls" onClick={onUnselectClick}>
              Select All
            </button>
          )}

          <TextField
            type="search"
            placeholder={searchPlaceholder}
            size="small"
            value={searchValue}
            style={{
              backgroundColor: "white",
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
            onChange={onSearchChange}
            onKeyDown={
              onKeyDown ||
              ((e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              })
            }
          />
        </Box>
      </div>
      <div className="listDivCls categoryDivCls">{children}</div>
    </Collapse>
  );
};

SearchableFilterContainer.propTypes = {
  isOpen: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  onSearchChange: PropTypes.func,
  selectAllFlag: PropTypes.bool,
  onUnselectClick: PropTypes.func,
  searchValue: PropTypes.string,
  helperText: PropTypes.string,
  onKeyDown: PropTypes.func,
  children: PropTypes.node,
};
